const NavLinks = () => {
  return (
    <>
      <li>
        <a href="#home">Home</a>
      </li>
      <li>
        <a href="#wgpt3">What is GPT?</a>
      </li>
      <li>
        <a href="#possibility">Open Ai</a>
      </li>
      <li>
        <a href="#features">Case Studies</a>
      </li>
      <li>
        <a href="#blog">Library</a>
      </li>
    </>
  );
};

export default NavLinks;
